<template>
    <div class="layout">
        <div class="layout_grid" id="section1">
            <div class="" v-for="(item, index) in anchor" :key="index">
                <a :href="'https://www.ftvnews.com.tw/topics/' + item.id" target="_blank">
                    <div class="layout_grid_inner">
                        <div class="layout_img">
                            <img v-bind:src="item.url" loading="lazy" alt=item.id />
                        </div>
                        <div class="layout_content">
                            <h2>{{ item.subtitle }}</h2>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            title: `民視數位專題`,
            newsInfo: [],
            anchor: [
            {
                    topictitle: '民視作伙過好年',
                    subtitle: '主播專屬拜年、景點推薦、過年小知識、過年實用台語線上看。',
                    content: '輕鬆點選即可收到民視新聞的新春祝福，還能查景點、看節目，陪你熱鬧迎接新年。',
                    id: `2026LunarNewYear/`,
                    url: 'https://www.ftvnews.com.tw/topics/topicsarea/img/2026newyearN.jpg',
                    time: `2026.02.09`,
                },
                {
                    topictitle: '2025大罷免時代 全台連署資訊',
                    subtitle: '2025大罷免時代 全台連署資訊｜罷免名單、門檻一次看',
                    content: '藍白兩黨強推爭議法案引爆民怨，全台進入大罷免時代。如何罷免立委？罷免門檻、連署程序是否合規？即時掌握全台罷免網站、連署進度與最新進展，民視新聞為您持續報導。',
                    id: `taiwanrecall`,
                    url: require('../assets/taiwanrecall.png'),
                    time: `2025.02.26`,
                },
                {
                    topictitle: '台灣廟世界',
                    subtitle: '【台灣廟世界】廟不可言、宇妙天下！台灣真奇廟與祂們的產地',
                    content: '有拜有保庇！台灣宮廟信仰深植人心，安定人們對大自然的惶恐不安。民俗月即將到來，說到台灣奇廟，你知道有玻璃蓋成的媽祖廟嗎？還有水中土地公與龍貓造型土地公；甚至還有住在大榕樹內的福德廟！民視新聞網特別製作台灣廟世界專題，不只應景農曆七月，更揭密台灣奇特廟宇文化。',
                    id: `taiwantemple`,
                    url: require('../assets/temple.png'),
                    time: `2022.08.12`,
                },
                {
                    topictitle: '台灣樂團專題',
                    subtitle: '台灣樂團專題｜時代的聲音！一窺台灣樂團歷史與獨立音樂發展',
                    content: '你對台灣獨立音樂了解有多少？民視新聞網邀請多組在地樂團與金曲歌王，專訪音樂人在業界的親身經歷，介紹台灣音樂歷史、LiveHouse展演空間文化，更揭密幕前、幕後的大小事，帶你更進一步了解音樂圈的故事。',
                    id: `taiwanband/`,
                    url: require('../assets/taiwanband.jpg'),
                    time: `2022.08.12`,
                },
                {
                    topictitle: '台灣兵役專題',
                    subtitle: '義務役恢復為1年！一覽國防與兵役沿革　台灣如何因應現代戰爭？',
                    content: '政府拍板2024年起恢復1年義務役制度！義務役二兵薪資調至26307元，訓練「立跪臥」3射擊姿勢都要會，更強化了新式武器訓練。延長兵役、增加役男人數，就能夠強化國防安全嗎？民視新聞網專訪到《阿共打來怎麼辦》作者王立，分析台灣兵役制度以及「不對稱作戰」優勢，以Q&A、圖表形式幫助大家理解。',
                    id: `soldier/`,
                    url: require('../assets/soilder.jpg'),
                    time: `2022.08.12`,
                },

                {
                    topictitle: '台灣民俗月專題',
                    subtitle: '台灣鬼怪不只林投姐與魔神仔？揭密台灣本土鬼怪傳說',
                    contentm: '你知道台灣也有自己的鬼怪文化嗎？民視新聞網特別製作台灣民俗月專題，用心理測驗跟專家訪談介紹台灣的本土文化、揭密台灣豐富的妖怪傳說。',
                    content: '你知道台灣也有自己的鬼怪文化嗎？民視新聞網特別製作台灣民俗月專題，用心理測驗跟專家訪談介紹台灣的本土文化、揭密台灣豐富的妖怪傳說。',
                    id: `taiwanghost`,
                    url: require('../assets/monster.jpg'),
                    time: `2022.08.12`,

                },
                // {
                //     topictitle: '疫情專區',
                //     subtitle: '【疫情專區】快篩陽了怎麼辦？確診隔離指引、疫情動態這邊看',
                //     content: '受到變種病毒Omicron侵襲，全球爆發新一波武漢肺炎（新冠肺炎、COVID-19）疫情，國內本土確診數也不斷飆高。<br>民視新聞特別製作數位專題，運用各式圖表，提供「台灣疫情整理」、「最新疫苗資訊」、「快篩實名制Q&A」等，讓讀者能掌握疫情資訊。',
                //     id: `covid-19/index.html`,
                //     url: require('../assets/covid.jpg'),
                //     time: `2022.08.22`,
                // },
                {
                    topictitle: '暖新聞專區',
                    subtitle: '暖新聞｜療癒毛孩、抗疫故事、勵志人物、國際暖聞、公益送暖',
                    content: '近日身處在疫情延燒、俄烏戰爭未見停歇、通膨風暴席捲全球的生活中，是否令你感到焦慮不安？或是高壓忙碌的工作，讓你感覺身心俱疲？<br>雖然日常生活裡，我們偶爾會低潮、憂鬱，但別忘了這個世界還是有很多好事發生！民視新聞網替大家精選療癒、正向暖新聞，希望為世界帶來一點正能量，鼓舞每個人帶著溫暖的心，繼續向前行。',
                    id: `warm`,
                    url: require('../assets/warm.jpg'),
                    time: `2022.08.12`,
                },
            ],
        }
    },

}
</script>

<style scoped>
.layout_img img {
    border-radius: 10px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px 0 0 10px;
}


.layout {
    width: 90%;
    margin: 2rem auto;
}

.layout_grid {
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr;
}


@media screen and (min-width: 600px) {
    .layout_grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1rem;
    }

    .layout_img img {
        border-radius: 10px 0 0 10px;
        width: 100%;
        height: 200px;
        object-fit: cover;

    }
}

@media screen and (min-width: 1000px) {
    .layout_grid {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 2rem;
    }

    .layout {
        width: 90%;
        margin: 2rem auto;
    }
}

.layout_grid_inner {
    display: grid;
    grid-template-columns: 3fr 4fr;
    box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 10px, rgba(17, 17, 26, 0.05) 0px px 10px;
    border-radius: 10px;
    box-shadow: rgb(85, 91, 255) 0px 0px 0px 3px, rgb(31, 193, 27) 0px 0px 0px 6px, rgb(255, 217, 19) 0px 0px 0px 9px, rgb(255, 156, 85) 0px 0px 0px 12px, rgb(255, 85, 85) 0px 0px 0px 110px;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

@media screen and (min-width: 1000px) {
    .layout_grid_inner {
        grid-template-columns: 1fr;
    }

}

.layout_grid_inner:hover {
    transition: .2s;
    filter: unset;
    opacity: .8;
}


a {
    text-decoration: none;
    color: #272727;
    text-align: start;
}

.layout_content {
    background: white;

    padding: 1rem;
    border-radius: 0 0 10px 10px;
    border-radius: 0 10px 10px 0;

}

@media screen and (min-width: 1000px) {
    .layout_content {
        border-radius: 0 0 10px 10px;
    }

    .layout_img img {
        border-radius: 10px 10px 0 0;

    }
}
</style>
